// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__d4ah8","label":"Completed_label__2ceMy"};